import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import { PrimaryButton } from "../../../ui/buttons/Button";
import useTable from "../../useTable";
import CatalogoModelo from "../../../catalogos/catalogoModelo";

export const GestionarModelo = (props) => {
  const op = require("../../../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const txtBuscador = useRef();
  const afiliado = JSON.parse(localStorage.getItem("riforganizacion"));
  const [activate, setActivate] = useState(false);
  const [catalogoModelo, setCatalogoModelo] = useState(false);
  const [operacion, setOperacion] = useState();
  const [modelo, setModelo] = useState({
    idmodelo: "",
    descripcion: "",
  });
  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "idmodelo",
      label: "CODIGO",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descripcion",
      label: "DESCRIPCION",
      width: "440px",
      textAlign: "left",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "accion",
      label: "OPCIONES",
      width: "180px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const seleccionarRegistros = async () => {
    try {
      setActivate(true);
      const campos = "*";
      const nomtab = "modelo";
      const orden = "idmodelo";
      const endpoint =
        op.conexion +
        `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
      axios
        .get(endpoint, {
          headers: {
            "x-access-token": `${token}`,
            "Content-Type": "application/json",
          },
        })
        .then(function (response) {
          if (response.status === 200) {
            setRecords(response.data);
          }
        })
        .catch(function (error) {})
        .finally(() => {
          txtBuscador.current?.focus();
        });
    } catch (error) {
    } finally {
      setActivate(false);
    }
  };
  const cerrar = () => {
    blanquear();
    if (props.onHideCancelar) props.onHideCancelar();
    if (props.setShow) props.setShow(false);
    props.cerrar();
  };
  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idmodelo.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const imprimir = () => {
    window.open(
      `${op.reportes}/comprasyalmacen?afiliado=${afiliado}&reporte=ListModelo`,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const blanquear = () => {};
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="header-azulGradiant">
        <h3>Gestion de Modelo.</h3>
        <a type="button" onClick={cerrar}>
          <i className="fa fa-times"></i>
        </a>
      </Modal.Header>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? cerrar()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} inverted></Dimmer>
      <div className="col-12">
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <div className="w-100 m-0 p-0 input-group input-group-sm text-uppercase">
              <input
                type={"text"}
                className="form-control text-uppercase"
                onChange={handleSearch}
                placeholder="Buscar Modelo..."
                ref={txtBuscador}
              />
              <button className="btn btn-sm btn-info" onClick={imprimir}>
                <i className="fas fa-print m-0" />
              </button>
            </div>
          </div>
          <div className="col-auto m-0 p-0">
            <PrimaryButton
              onClick={() => {
                setModelo();
                setCatalogoModelo(true);
                setOperacion(1);
              }}
              className="btn btn-sm btn-info"
              icon="fa-plus m-0"
            />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr key={item.idmodelo} style={{ padding: "0" }}>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "10px",
                      }}
                    >
                      {item.idmodelo}
                    </td>
                    <td
                      style={{
                        fontSize: "14px",
                        textAlign: "left",
                        width: "auto",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      className="mx-auto"
                      align="center"
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                        width: "120px",
                      }}
                    >
                      <button
                        onClick={() => {
                          setModelo(item);
                          setCatalogoModelo(true);
                          setOperacion(4);
                        }}
                        className={"btn btn-sm btn-info rounded-circle"}
                      >
                        <i className="fas fa-eye"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={() => {
                          setModelo(item);
                          setCatalogoModelo(true);
                          setOperacion(2);
                        }}
                        className={"btn btn-sm btn-warning rounded-circle"}
                      >
                        <i className="fa fa-edit"></i>
                      </button>
                      <a> &nbsp; </a>
                      <button
                        onClick={() => {
                          setModelo(item);
                          setCatalogoModelo(true);
                          setOperacion(3);
                        }}
                        className={"btn btn-sm btn-danger rounded-circle"}
                      >
                        <i className="fa fa-trash-alt"></i>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </div>
      <CatalogoModelo
        show={catalogoModelo}
        modelo={modelo}
        onHideCancelar={() => setCatalogoModelo(false)}
        onHideRenderizar={seleccionarRegistros}
        operacion={operacion}
      />
    </Modal>
  );
};
